module.exports = __webpack_public_path__ + "static/media/m.49375dc6.png";